// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"3ff4f91a","787":"6558f370"}[chunkId] + ".chunk.js";
};